export default {
  env: 'staging',
  kibanaApi: 'https://api-support-test.xfinity.com/logger/',
};
